$(document).on('turbolinks:load', function() {
  
  var downloaded_badge = "<span class='badge badge-dark'>Exported</span>"

  $('.account_channel_radio_button').addClass('disabled');
  $('.search_term_radio_button').addClass('disabled');
  $('.group_radio_button').addClass('disabled');

  $('#list_csv_export').click(function(e){
    e.preventDefault();

    if (confirm('Are You Sure?')){
      $(this).addClass( "disabled" );
    }
    else {
      return false;
    }

  })

  $('.term_csv_export').click(function(e){
    e.preventDefault();

    if (confirm('Are You Sure?')){
      $(this).addClass( "disabled" );
      $(this).text("Exported")
    }
    else {
      return false;
    }

  })

  $('#user-filter').select2({
    theme: "bootstrap4",
    placeholder: "Select a User"
  });

  $('#user-filter').on('select2:select', function (e) { 
    let url = new URL(window.location.href);

    if($('#user-filter').val() != "all"){
      var val = $('#user-filter').val()
      url.searchParams.set('user', val)

    } else {
      url.searchParams.delete('user')
    }

    window.location.href = url.href;

  });

  $('.collect-historical-btn').on('click', function(e){
    e.preventDefault();

    if (confirm('Are you sure?')){
      var list_id = $(this).attr("data-list-id");
      var type = $(this).attr("data-type");
      var obj_id = ""

      if(type == "channels") {
        obj_id = $(this).attr("data-channel-id");
      } else {
        obj_id = $(this).attr("data-search-term-id");
      }

      $.ajax({
        type: "POST",
        url: `/${type}/${obj_id}/import_historical_data?list_id=${list_id}`,
        data: {},
        success: (response) => {
          alert(response["message"])
        },
        error: function(response) {
          alert("Something went wrong. Please try again.")
        }
        
      });
    }
    else {
      return false;
    }
    
  })

  $('.platforms_dropdown').on('click', function () {
    var channel_enabled = $(this)[0].dataset.channel;
    var search_enabled = $(this)[0].dataset.search;
    var group_enabled = $(this)[0].dataset.group;

    $(".account_checked").prop("checked", false);
    $(".term_checked").prop("checked", false);
    $(".group_checked").prop("checked", false);

    $(".account_channel_radio_button").removeClass("active");
    $(".search_term_radio_button").removeClass("active");
    $(".group_radio_button").removeClass("active");

    if (channel_enabled == "true"){
      $('.account_channel_radio_button').removeClass('disabled')
    } else {
      $('.account_channel_radio_button').addClass('disabled')
    } 

    if (search_enabled == "true"){
      $('.search_term_radio_button').removeClass('disabled')
    } else {

      $('.search_term_radio_button').addClass('disabled')
    } 

    if (group_enabled == "true"){
      $('.group_radio_button').removeClass('disabled')
    } else {
      $('.group_radio_button').addClass('disabled')
    }
  })

  $('#list_multi_platform').change(function(){
    if ($(this).is(':checked') == true){
      $(".platform-select label").each(function(label, elem){ $(elem).addClass('disabled')});
      $(".platform-select input").each(function(label, elem){ $(elem).prop('disabled', true)});
    } else {
      $(".platform-select label").each(function(label, elem){ $(elem).removeClass('disabled')});
      $(".platform-select input").each(function(label, elem){ $(elem).prop('disabled', false)});
    }
  });

});